import React from "react"
import Arrow from "../../images/arrow_orange.svg"
import ArrowWhite from "../../images/arrow_white.svg"
import TicketList from "./TicketList"
import {
  Container,
  InfoIcon,
  ArrowContainer,
  InfoName,
  ArrowUp,
  AccordionInfo,
  InfoContainer,
  HeaderContainer,
} from "../../styles/ticketAccordion.style"

export default function TicketAccordion({
  id,
  icon,
  name,
  tickets,
  background,
  deepLink,
  openOption,
  setOpenOption,
  openDownloadModal,
}) {
  const toggleDetail = () =>
    id === openOption ? setOpenOption(-1) : setOpenOption(id)

  return (
    <Container>
      <HeaderContainer
        color={background ? background : null}
        onClick={toggleDetail}
      >
        <InfoContainer>
          <InfoIcon src={icon} alt={name} />
          <InfoName>{name}</InfoName>
        </InfoContainer>

        <ArrowContainer>
          <ArrowUp
            src={background ? ArrowWhite : Arrow}
            open={openOption === id}
          />
        </ArrowContainer>
      </HeaderContainer>
      <AccordionInfo open={openOption === id}>
        {tickets.map(ticket => (
          <TicketList
            deepLink={deepLink}
            ticket={ticket}
            key={ticket.id}
            openDownloadModal={openDownloadModal}
          />
        ))}
      </AccordionInfo>
    </Container>
  )
}
